import type { SubscriptionV2Variable } from "@/pages/subscriptions/services/types";

interface SubscriptionDescriptionRendererProps {
  prompt: string;
  variables: SubscriptionV2Variable[];
}

const SubscriptionDescriptionRenderer = ({
  prompt,
  variables,
}: SubscriptionDescriptionRendererProps) => {
  const renderPromptParts = () => {
    const parts: JSX.Element[] = [];
    let lastIndex = 0;
    const regex = /\{\{(\w+)\}\}/g;
    let match;

    while ((match = regex.exec(prompt)) !== null) {
      // Add text before the variable
      if (match.index > lastIndex) {
        parts.push(
          <span key={`text-${lastIndex}`} className="al-text-gray-700">
            {prompt.slice(lastIndex, match.index)}
          </span>
        );
      }

      // Add the variable value as bold text (not a pill)
      const variableId = match[1];
      const variable = variables.find(v => v.id === variableId);
      if (variable) {
        parts.push(
          <span key={`var-${variableId}`} className="al-font-bold al-text-gray-900">
            {variable.displayValue}
          </span>
        );
      }

      lastIndex = match.index + match[0].length;
    }

    // Add remaining text
    if (lastIndex < prompt.length) {
      parts.push(
        <span key={`text-${lastIndex}`} className="al-text-gray-700">
          {prompt.slice(lastIndex)}
        </span>
      );
    }

    return parts;
  };

  return (
    <div className="al-text-base al-leading-relaxed al-text-gray-700">{renderPromptParts()}</div>
  );
};

export default SubscriptionDescriptionRenderer;
